<script>
    import Modal from "./Modal.svelte";
    import { createEventDispatcher } from "svelte";
    import Button from "../Button.svelte";
    import { l } from "../../Utils/l10n.svelte";

    export let id="";
    export let title = undefined;
    export let okButtonText = l("OK");
    export let cancelButtonText = l("Annuleren");
    export let message = undefined;
    export let offsetTopLeft = 0;

    const dispatch = createEventDispatcher();

    function doYes() {
        dispatch("continue");
    }

    function doNo() {
        dispatch("cancel");
    }
</script>

<Modal {title} {offsetTopLeft} {id}>
    <p>{@html message}</p>
    <div slot="footer" class="buttons">
        <Button transparent={false} on:click={doYes} text={okButtonText} />
        <Button
            transparent={false}
            bump={true}
            on:click={doNo}
            text={cancelButtonText}
        />
    </div>
</Modal>

<style>
    .buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 0 0.5rem 0.5rem 0.5rem;
    }
</style>
